"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactInfoPanel = void 0;
var PersonalFormCard_cms_1 = require("../components/cards/PersonalFormCard/PersonalFormCard.cms");
var companycontactdetailscard_cms_1 = require("../components/cards/WorkServiceConflictCard/CompanyContactDetailsCard/companycontactdetailscard.cms");
var workserviceconflictcard_cms_1 = require("../components/cards/WorkServiceConflictCard/workserviceconflictcard.cms");
var ContactInfoPanel = /** @class */ (function () {
    function ContactInfoPanel() {
        this.personalform = new PersonalFormCard_cms_1.PersonalFormCardCms();
        this.companyContactDetails = new companycontactdetailscard_cms_1.CompanyContactDetailsCardCms();
        this.workServiceConflict = new workserviceconflictcard_cms_1.WorkServiceConflictCardCms();
    }
    return ContactInfoPanel;
}());
exports.ContactInfoPanel = ContactInfoPanel;
//# sourceMappingURL=ContactInfoPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/ContactInfoPanel.cms.js
// module id = 1978
// module chunks = 8